import { render, staticRenderFns } from "./CrashHistoryElement.vue?vue&type=template&id=25824423&scoped=true"
import script from "./CrashHistoryElement.vue?vue&type=script&lang=js"
export * from "./CrashHistoryElement.vue?vue&type=script&lang=js"
import style0 from "./CrashHistoryElement.vue?vue&type=style&index=0&id=25824423&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25824423",
  null
  
)

export default component.exports